'use strict';

module.exports = function hasParentClass(elem, classname) {
    if (elem === document) {
        return false;
    }

    if (elem.classList.contains(classname)) {
        return true;
    }

    return elem.parentNode && hasParentClass(elem.parentNode, classname);
}



// WEBPACK FOOTER //
// ./resources/js/utilities/domHelpers.js